<template>
  <div class="stationReferrerConfig">
    <div class="top util-remark">
      * 推广设置适用于拥有站外推广售票员售票的业务场景<br/>
      * 推广售票提成、分销提成将计入用户个人钱包余额中
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-position="left">
      <el-form-item label="售票提成" required>
        <div>
          <div>
            <el-switch v-model="form.commissionConfig" :active-value="1" :inactive-value="2"></el-switch>
            <span class="el-form-item-remark"
                  style="display: inline-block; padding-left: 8px">如关闭，则推广售票员在移动售票端口售出车票将不会进行提成</span>
          </div>
          <div style="height: 10px"></div>
          <div class="top util-remark">
            * 阶梯设置[0元～10元)，则金额为0～9.9元(不包含10元)的客票皆可触发该阶梯提成<br/>
            * 推广售票提成仅在车票已检票且行程完成后才会发放至用户钱包余额中
          </div>
          <div style="height: 10px"></div>
          <div v-for="(item, index) in form.commissionRule" :key="index" style="display: flex;margin-bottom: 0px">
            <span style="margin-right: 6px">当客票金额为</span>
            <el-form-item label="" :prop="'commissionRule.' + index + '.minFee'"
                          :rules="[{ required:true, message: '请输入金额' }]">
              <el-input :disabled="index>0" v-input-filter="{ min: 0, max: 999999, precision: 2 }" style="width: 130px"
                        v-model="item.minFee" placeholder="请输入金额">
                <template slot="suffix">元</template>
              </el-input>
            </el-form-item>
            <span style="margin:0 6px">至</span>
            <el-form-item label="" :prop="'commissionRule.' + index + '.maxFee'"
                          :rules="[{ required: true, message: '请输入金额' }, { validator: validateFee,subIndex:index,maxFee:item.maxFee, minFee:item.minFee,trigger: ['blur','change'] }]">
              <el-input :disabled="index<(form.commissionRule.length - 1)" v-input-filter="{ min: 0, max: 999999, precision: 2 }" style="width: 130px"
                        v-model="item.maxFee" placeholder="请输入金额">
                <template slot="suffix">元</template>
              </el-input>
            </el-form-item>
            <span style="margin:0 6px">每张客票提成</span>
            <el-form-item label="" :prop="'commissionRule.' + index + '.fee'"
                          :rules="[{ required: true, message: '请输入百分比' }]">
              <el-input  v-input-filter="{ min: 0, max: 100, precision: 2 }" style="width: 130px"
                        v-model="item.fee"
                        placeholder="请输入百分比">
                <template slot="suffix">%</template>
              </el-input>
            </el-form-item>

            <span v-if="index>0 && (index + 1) == form.commissionRule.length"
                  style="margin-left: 20px;color: #1e8fe9;cursor: pointer" @click="deleteList(index)"
                  class="testlist">删除
            </span>
          </div>

          <div v-if="form.commissionRule.length<5" class="add" @click="addClicks">
            <i class="el-icon-plus"></i>添加推广售票提成规则
          </div>
        </div>
      </el-form-item>

      <el-form-item label="推广提成" required>
        <div>
          <div style="margin-bottom: 10px">
            <el-switch v-model="form.distributionConfig" :active-value="1" :inactive-value="2"></el-switch>
            <span class="el-form-item-remark"
                  style="display: inline-block; padding-left: 8px">如关闭，则售票员在移动售票端口售出车票后将不会提成给邀请人</span>
          </div>
          <el-form-item label-width="0px" prop="distributionRatio">
            提取客票金额的
            <el-input v-input-filter="{ min: 0.01, max: 100, precision: 2 }" style="width: 130px"
                      v-model="form.distributionRatio">
              <template slot="suffix">%</template>
            </el-input>
          </el-form-item>


        </div>
      </el-form-item>
      <el-form-item label="最低结算金额" required>
        <div>
          <div style="margin-bottom: 10px">
            <el-switch v-model="form.settleConfig" :active-value="1" :inactive-value="2"></el-switch>
            <span class="el-form-item-remark"
                  style="display: inline-block; padding-left: 8px">如关闭，则不限制用户每次最低可结算金额</span>
          </div>
          <el-form-item label-width="0px" prop="settleMinFee">
            每次最低可结算
            <el-input v-input-filter="{ min: 0, max: 999999, precision: 2 }" style="width: 130px"
                      v-model="form.settleMinFee">
              <template slot="suffix">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item>
      <el-form-item style="padding: 10px 0 50px 0">
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "stationReferrerConfig",
  data() {
    return {
      loading: false,
      form: {
        distributionRatio: '',
        settleMinFee: '',
        commissionConfig: 2,
        distributionConfig: 2,
        settleConfig: 2,
        commissionRule: [{
          minFee: '',
          maxFee: "",
          fee: ''
        }]
      },
      rules: {
        distributionRatio: [{required: true, message: '请输入客票金额', trigger: ['blur', 'change']}],
        settleMinFee: [{required: true, message: '请输入最低结算金额', trigger: ['blur', 'change']}],
      }
    }
  },
  mounted() {
    this.getInitFn()
  },
  methods: {
    async getInitFn() {
      this.loading = true
      const url = "/api/v1/manage/systems/station/referrer"
      this.loading = false
      const {code, data} = await this.$axios.get(url, {
        organizationId: this.mixinUserInfo.organizationId
      })
      if (code === 1) {
        this.form = {
          ...this.form,
          ...data,
          commissionRule:data.commissionRule?data.commissionRule:this.form.commissionRule
        }
        this.rules.distributionRatio[0].required = this.form.distributionConfig === 1
        this.rules.settleMinFee[0].required = this.form.settleConfig === 1
      }
    },
    validateFee(rule, value, callback) {
      if (Number(rule.minFee) >= Number(rule.maxFee)) {
        callback('不能小于最小金额')
      }
      callback();
    },
    async postFn() {
      this.loading = true
      const url = "/api/v1/manage/systems/station/referrer"
      this.loading = false
      const {code} = await this.$axios.post(url, {
        ...this.form,
        commissionRule: JSON.stringify(this.form.commissionRule),
      })
      if (code === 1) {
        this.$message.success('操作成功')
      }
    },
    saveClick() {
      this.rules.distributionRatio[0].required = this.form.distributionConfig === 1
      this.rules.settleMinFee[0].required = this.form.settleConfig === 1
      this.$nextTick(() => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.postFn()
          } else {
            console.log(44);
            this.$message.warning("请检查表单数据是否输入正确！");
            return false;
          }
        });
      })
    },
    deleteList(index) {
      this.form.commissionRule.splice(index, 1)
    },
    addClicks() {
      this.rules.distributionRatio[0].required = this.form.distributionConfig === 1
      this.rules.settleMinFee[0].required = this.form.settleConfig === 1
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.commissionRule.push({
            minFee: this.form.commissionRule[this.form.commissionRule.length - 1].maxFee || '',
            maxFee: "",
            fee: ''
          })
        }
      })

    }
  }
}
</script>

<style scoped lang="less">
.stationReferrerConfig {

  .top {
    background-color: #f3f4f5;
    padding: 10px 12px;
    box-sizing: border-box;
  }

  .add {
    margin-top: 12px;
    width: 515px;
    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }
}

</style>